import React from 'react'

const ValueMovement = ({ value, component }) => {
    let statIcon = 'right'

    if (value === null || value === undefined) return null

    if (value < 0) {
        statIcon = 'down'
    }
    if (value > 0) {
        statIcon = 'up'
    }
    return (
        <div className={`stat-compare ${statIcon}`}>
            <i className={`fa fa-arrow-${statIcon}`} />
            {React.createElement(component, { value })}
        </div>
    )
}

export default ValueMovement
